import color from './colorThemes'

export default {
  source: 'osm',
  'source-layer': 'landusages',
  id: 'wood',
  type: 'fill',
  filter: ['in', 'type', 'forest', 'wood'],
  paint: {
    'fill-color': color.wood,
    'fill-pattern': 'wood-32',
  },
}
